import { useEffect, useState } from "react";
import { getGroupRoles } from "../services/groupService";

interface IUseFetchGroupRoles {
  setIsLoading?: React.Dispatch<React.SetStateAction<boolean>>;
  groupId: string | number | null | undefined;
}

const useFetchGroupRoles = ({ setIsLoading, groupId }: IUseFetchGroupRoles) => {
  const [groupRoles, setGroupRoles] = useState<number[]>([]);

  useEffect(() => {
    if (!groupId) {
      setGroupRoles([]);
      return;
    }

    const fetchGroupRoles = async () => {
      if (setIsLoading) {
        setIsLoading(true);
      }

      try {
        const response = await getGroupRoles(groupId);

        // Extract role IDs from the response
        console.log("response", response);
        setGroupRoles(response || []);
      } catch (err) {
        console.error("Error fetching group roles:", err);
        setGroupRoles([]);
      } finally {
        if (setIsLoading) {
          setIsLoading(false);
        }
      }
    };

    fetchGroupRoles();
  }, [groupId, setIsLoading]);

  return [groupRoles, setGroupRoles] as const;
};

export default useFetchGroupRoles;
